let documentScrollAmount = 0;

function setMetaElement(property: string, content: string) {
  const metaDescriptionTag = document.querySelector('meta[name="description"]');

  const metaElement = document.querySelector(`meta[property="${property}"]`);
  if (metaElement) {
    metaElement.setAttribute('content', content);
  } else {
    const newMetaElement = document.createElement('meta');
    newMetaElement.setAttribute('property', property);
    newMetaElement.setAttribute('content', content);

    if (metaDescriptionTag && metaDescriptionTag.parentNode) {
      metaDescriptionTag.parentNode.insertBefore(
        newMetaElement,
        metaDescriptionTag.nextSibling
      );
    }
  }
}

const DocumentBackend = {
  invoke: {
    getCookies: (): string => document.cookie || '',
    getElementScrollLeft: ([id]: [string]) => {
      const element = document.getElementById(id);

      return element ? element.scrollLeft : 0;
    },
    setTitle: ([title]: [string]) => {
      document.title = title;
    },
    setMetaDescription: ([description]: [string]) => {
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );

      metaDescription && metaDescription.setAttribute('content', description);
    },
    manageRobotsTag: ([noindex, notranslate]: [boolean, boolean]) => {
      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      const metaRobotsTag = document.querySelector('meta[name="robots"]');
      const metaRobotsIndex = noindex ? 'noindex, nofollow' : 'index, follow';
      const metaRobotsValue =
        metaRobotsIndex + (notranslate ? ', notranslate' : '');

      if (!metaRobotsTag) {
        const newRobotsTag = document.createElement('meta');
        newRobotsTag.setAttribute('name', 'robots');
        newRobotsTag.setAttribute('content', metaRobotsValue);
        if (metaDescriptionTag && metaDescriptionTag.parentNode) {
          metaDescriptionTag.parentNode.insertBefore(
            newRobotsTag,
            metaDescriptionTag.nextSibling
          );
        }
      } else {
        metaRobotsTag.setAttribute('content', metaRobotsValue);
      }
    },
    setCanonicalTag: ([pageUrl]: [string]) => {
      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      const canonical = document.querySelector('link[rel="canonical"]');

      if (!canonical) {
        const canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        canonicalTag.setAttribute('href', pageUrl);
        if (metaDescriptionTag && metaDescriptionTag.parentNode) {
          metaDescriptionTag.parentNode.insertBefore(
            canonicalTag,
            metaDescriptionTag.nextSibling
          );
        }
      } else {
        canonical.setAttribute('href', pageUrl);
      }
    },
    removeHreflangTags: ([canonical]: [object]) => {
      let hreflangTags = document.querySelectorAll('link[hreflang]');

      if (!canonical || !hreflangTags) {
        return;
      } else {
        for (let i = 0, j = hreflangTags.length; i < j; i++) {
          hreflangTags[i].remove();
        }
      }
    },
    setSchemaMarkUp: ([data]: [string]) => {
      const scriptEl = document.querySelector(
        'script[data-id="application/schema"]'
      );
      if (scriptEl) {
        scriptEl.remove();
      }

      if (data) {
        const scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.setAttribute('data-id', 'application/schema');

        try {
          // check the validity of a string whether it is a JSON string or not
          // remove unnecessary spaces and line breaks
          const jsonObj = JSON.parse(data);
          const jsonStr = JSON.stringify(jsonObj);
          scriptTag.text = jsonStr;
        } catch (e) {
          console.error(
            'Incorrect SEO data for the page. Check CMS configuration.',
            e
          );
        }

        document.head.appendChild(scriptTag);
      }
    },
    setBodyNonScrollable: () => {
      documentScrollAmount = window.scrollY;
      document.documentElement.classList.add('non-scrollable');
      document.documentElement.style.top = `-${documentScrollAmount}px`;
    },
    setBodyScrollable: () => {
      document.documentElement.classList.remove('non-scrollable');
      window.scrollTo(0, documentScrollAmount);
    },
    OpenGraph: {
      setTitle: (title: string) => {
        setMetaElement('og:title', title);
      },
      setURL: (pageUrl: string) => {
        setMetaElement('og:url', pageUrl);
      },
      setDescription: (description: string) => {
        setMetaElement('og:description', description);
      },
      setType: (type: string) => {
        setMetaElement('og:type', type);
      },
      setImage: (imageUrl: string) => {
        setMetaElement('og:image', imageUrl);
      },
    },

    TwitterCards: {
      setTitle: (title: string) => {
        setMetaElement('twitter:title', title);
      },
      setURL: (pageUrl: string) => {
        setMetaElement('twitter:url', pageUrl);
      },
      setDescription: (description: string) => {
        setMetaElement('twitter:description', description);
      },
      setType: (type: string) => {
        setMetaElement('twitter:card', type);
      },
      setImage: (imageUrl: string) => {
        setMetaElement('twitter:image', imageUrl);
      },
    },
  },
};
export default DocumentBackend;
